import React from 'react'
import PropTypes from 'prop-types'

const BudgetLabel = ({stage, description, address, detail}) => {
    return (
        <div className="d-flex flex-column">
            {stage && <small>Stage: {stage}</small>}
            <span>{description}</span>
            {address && <small>{address}</small>}
            {detail && <small>{detail}</small>}
        </div>
    )
}

BudgetLabel.propTypes = {
    stage: PropTypes.string,
    description: PropTypes.string.isRequired,
    address: PropTypes.string,
    detail: PropTypes.string
}

export default BudgetLabel